import React from "react";
import get from "lodash/get";
import find from "lodash/find";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Icon,
  Layout,
  Input,
  Table,
  Tooltip,
  Badge,
  Select,
} from "antd";
import { Link } from "react-router-dom";
import moment from "moment-timezone";


import Footer from "../../components/Footer/Footer";
import classes from "./EnrolmentsRandomize.css";

import isAuthenticated from "../../utils/isAuthenticated";
import { getSubjectSearchRequest } from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import { withParams } from "../../utils/url";
import {
  getUserShortTimezone,
  getUserTimezone,
} from "../../reducers/user/selectors";
import { withNamespaces } from "react-i18next";

const routes = require("../../routes.json");

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;

const renderIcon = (status) => {
  return (
    <div className={classes.iconStatusWrapper}>
      {status === "green" && (
        <Icon type="check-square" className={classes.checkIcon} />
      )}
      {status === "red" && (
        <Icon type="warning" className={classes.warningIcon} />
      )}
      {status === "orange" && (
        <Icon type="clock-circle" className={classes.clockIcon} />
      )}
      {status === "gray" && (
        <Icon type="clock-circle" className={classes.checkIconGray} />
      )}
      {status === "pending" && (
        <Icon type="clock-circle" className={classes.checkIconGray} />
      )}
    </div>
  );
};

class EnrolmentsRandomize extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      subject: [],
      subjectSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      site: null,
      filter: "event",
      order: "asc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: { [this.props.match.params.listName]: false },
      drug_status: "allocated",
      sortedInfo: { columnKey: "status", order: "ascend" },
    };
  }

  componentDidMount() {
    this.onSubjectSearch();
  }

  componentWillReceiveProps(nextProps) {
    this.setState(
      { eventsSelected: { [nextProps.match.params.listName]: false } }
    );
  }

  onSubjectSearch = async (value) => {
    this.setState({ subjectSearch: value, site: null, currentPage: 1 }, this.getSubjects);
  };

  getSubjects = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getSubjectSearchRequest({
        subjectSearch: this.state.subjectSearch,
        filter_by: this.state.filter,
        site_code: this.state.site,
        events: Object.keys(this.state.eventsSelected).join(","),
        event_status: Object.values(this.state.eventsSelected).join(","),
        order_direction: this.state.order,
        drug_status:
          this.props.match.params.listName === "validation"
            ? this.state.drug_status
            : undefined,
        page,
        per_page,
        order_column: get(this.state, "sortedInfo.columnKey"),
        withEvents: true
      });

      if (Array.isArray(data.data)) {
        this.setState({
          subject: data.data,
          total: data.total_pages * per_page,
          currentPage: page,
        });
      } else {
        this.setState({
          subject: [data],
          total: 1 * per_page,
          currentPage: page,
        });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  onSubjectChange = (e) => {
    this.setState({ subjectSearch: e.target.value });
  };

  clearFilters = () => {
    this.setState(
      { subjectSearch: null, site: null, sortedInfo: null, currentPage: 1 },
      this.getSubjects
    );
  };

  handleFilterChange = (value) => {
    this.setState(
      {
        filter: value,
        site: null,
        eventsSelected: {},
        subjectSearch: null,
        sortedInfo: null,
        currentPage: 1
      },
      this.getSubjects
    );
  };
  handleSiteChange = (value) => {
    this.setState({ site: value, sortedInfo: null, currentPage: 1 }, this.getSubjects);
  };
  handleOrderChange = (value) => {
    this.setState({ order: value, sortedInfo: null }, this.getSubjects);
  };

  handleMenuClick = (e) => {
    if (e.key === "3") {
      this.setState({ eventVisibleDropdown: false });
    }
  };

  handleVisibleChange = (flag) => {
    this.setState({ eventVisibleDropdown: flag });
  };

  hideEventDropdown = () => {
    this.setState({ eventVisibleDropdown: false });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getSubjects(pagination.current, pagination.pageSize)
    );
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      subjectSearch,
      subject,
      currentPage,
      total,
      pageSize,
      sortedInfo,
      drug_status,
    } = this.state;

    const columns = [
      {
        dataIndex: "code",
        key: "status",
        title: this.props.i18n.t("Status"),
        render: (val, row) => (
          <div>
            {val && (
              <Link
                to={withParams(routes.admin.validateRandomizationAdmin, {
                  subjectID: val,
                  site: get(row, "site.code"),
                })}
              >
                <Button size="small" type="primary">
                  {val}
                </Button>
              </Link>
            )}
            <br />
            <Badge
              count={row.state}
              style={{
                backgroundColor: row.state === "active" ? "#49c850" : "#f00",
                margin: '10px 0 0'
              }}
            />
            <br />
            {get(row, "profile") ? (
              <Tooltip
                placement="topLeft"
                title={
                  get(row, "profile.locked")
                    ? `${this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:Locked by"
                      )} ${get(row, "profile.locked_by_username")}`
                    : this.props.i18n.t("NamespaceEnrolmentsRandomize:Unlocked")
                }
              >
                <Badge
                  count={
                    get(row, "profile.locked")
                      ? this.props.i18n.t("NamespaceEnrolmentsRandomize:Locked")
                      : this.props.i18n.t("Unlocked")
                  }
                  style={{
                    backgroundColor: get(row, "profile.locked")
                      ? "#f00"
                      : "#49c850",
                    textTransform: "none",
                  }}
                />
              </Tooltip>
            ) : (
              ""
            )}
            <br />
            {get(row, "profile.locked_date") ? (
              <Badge
                count={`${this.props.i18n.t(
                  "NamespaceEnrolmentsRandomize:Locked at"
                )} ${moment
                  .utc(get(row, "profile.locked_date"))
                  .tz(
                    this.props.userTimezone ||
                      get(row, "site.time_zone") ||
                      "UTC"
                  )
                  .format("YYYY-MM-DD HH:mm")} ${
                  this.props.userShortTimezone ||
                  get(row, "site.short_tz") ||
                  "UTC"
                }`}
                style={{ backgroundColor: "#f00" }}
              />
            ) : (
              ""
            )}
          </div>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "status" && sortedInfo.order,
      },
      {
        dataIndex: "profile",
        key: "profile_id",
        title: this.props.i18n.t("NamespaceEnrolmentsRandomize:Profile ID"),
        render: (val, row) => (
          <div>
            <Tooltip
              placement="topLeft"
              title={this.props.i18n.t("View Subject Profile")}
            >
              <Link
                to={withParams(routes.admin.patientProfileSingle, {
                  subjectID: get(val, "code"),
                })}
              >
                {get(val, "code")}
              </Link>
            </Tooltip>
            <br />
            {get(row, "profile.date_when_tested_positive") && (
              <div>
                {this.props.i18n.t(
                  "NamespaceEnrolmentsRandomize:Positive days"
                )}
                :&nbsp;
                {/*{moment(row.randomization_date || new Date()).diff(moment(get(row, 'profile.date_when_tested_positive')).tz(this.props.userTimezone || get(row, 'site.site_timezone') || 'UTC'), 'days')}*/}
                {(() => {
                  const currentDate = row.randomization_date
                    ? moment
                        .utc(row.randomization_date)
                        .tz(
                          this.props.userTimezone ||
                            get(this.props, "site.site_timezone") ||
                            "UTC"
                        )
                        .format("YYYY-MM-DD")
                    : new Date();
                  return moment(currentDate).diff(
                    moment(get(row, "profile.date_when_tested_positive"))
                      .tz(
                        this.props.userTimezone ||
                          get(this.props, "site.site_timezone") ||
                          "UTC"
                      )
                      .format("YYYY-MM-DD"),
                    "days"
                  );
                })()}
              </div>
            )}
          </div>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "profile_id" && sortedInfo.order,
      },
      {
        dataIndex: "created",
        key: "created",
        title: this.props.i18n.t(
          "NamespaceEnrolmentsRandomize:Profile created"
        ),
        render: (val, record) => (
          <span>
            {moment
              .utc(val)
              .tz(
                this.props.userTimezone ||
                  get(record, "site.time_zone") ||
                  "UTC"
              )
              .format("YYYY-MM-DD HH:mm")}{" "}
            {this.props.userShortTimezone ||
              get(record, "site.short_tz") ||
              "UTC"}
          </span>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "created" && sortedInfo.order,
      },
      /*{
        dataIndex: "profile",
        key: "is_completed",
        title: this.props.i18n.t('Profile completed'),
        render: (val, record) => (
          <span>
            {renderIcon(get(val, 'is_completed') ? 'green' : 'red')}
            {get(val, 'profile_completed_date') &&
            <span><br/>{moment.utc(val.profile_completed_date.toString()).tz(this.props.userTimezone || get(record, 'site.time_zone') || 'UTC').format('YYYY-MM-DD HH:mm')} {this.props.userShortTimezone || get(record, 'site.short_tz') || 'UTC'}</span>
            }
          </span>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'is_completed' && sortedInfo.order,
      },*/
      {
        dataIndex: "events_summary_report",
        key: "profile",
        title: this.props.i18n.t("Patient profile"),
        render: (val) => (
          <span>
            {renderIcon(
              get(
                find(val, (event) => event.event === "profile"),
                "status"
              )
            )}
          </span>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "profile" && sortedInfo.order,
      },
      {
        dataIndex: "events_summary_report",
        key: "randomize",
        title: this.props.i18n.t("Randomization occurred"),
        render: (val) => (
          <span>
            {renderIcon(
              get(
                find(val, (event) => event.event === "randomize"),
                "status"
              )
            )}
          </span>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "randomize" && sortedInfo.order,
      },
      {
        dataIndex: "events_summary_report",
        key: "treatment_allocated",
        title: this.props.i18n.t("Drug Allocated"),
        render: (val) => (
          <span>
            {renderIcon(
              get(
                find(val, (event) => event.event === "treatment_allocated"),
                "status"
              )
            )}
          </span>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "treatment_allocated" && sortedInfo.order,
      },
      {
        dataIndex: "events_summary_report",
        key: "death",
        title: this.props.i18n.t("Death"),
        render: (val, record) => {
          const found = find(val, (event) => event.event === "death");
          const deathUndefinedStatus = get(
                found,
                "status",
                undefined
              );
          return(
            <span>
              {!!deathUndefinedStatus && deathUndefinedStatus !== "none" && <span>Yes</span>}
            </span>
        )},
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "death" && sortedInfo.order,
      },
    ];

    if (this.props.match.params.listName === "validation") {
      columns.splice(1, 0, {
        dataIndex: "drug",
        key: "drug",
        title: this.props.i18n.t("NamespaceEnrolmentsRandomize:Drug"),
        render: (val) => (
          <div>
            {get(val, "vial_number")}
            <br />
            <Badge
              count={get(val, "drug_status", "").replace(/_/g, " ")}
              style={{ backgroundColor: "#2968AE" }}
            />
          </div>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "drug" && sortedInfo.order,
      });
    }

    return (
      <div>
        <Layout className={classes.parentContainer}>

          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("Subject")} {this.props.match.params.listName}{" "}
              {this.props.i18n.t("NamespaceEnrolmentsRandomize:list")}
            </h3>

            <div className={classes.searchWrapper}>
              <label className={classes.searchWrapperSearch}>
                <b className={classes.searchWrapperLabel}>
                  {this.props.i18n.t("SEARCH")}
                </b>
                <Search
                  placeholder={this.props.i18n.t(
                    "NamespaceEnrolmentsRandomize:By subjectID"
                  )}
                  enterButton={this.props.i18n.t("Search")}
                  size="large"
                  onSearch={this.onSubjectSearch}
                  value={subjectSearch}
                  onChange={this.onSubjectChange}
                  style={{ maxWidth: "500px" }}
                />
              </label>

              {this.props.match.params.listName === "validation" && (
                <div style={{ width: "250px" }}>
                  <b style={{ display: "block", marginBottom: "3px" }}>
                    {this.props.i18n.t("Drug status")}
                  </b>
                  <Select
                    onChange={(val) =>
                      this.setState({ drug_status: val, currentPage: 1 }, this.getSubjects)
                    }
                    value={drug_status}
                    style={{ width: "100%" }}
                  >
                    <Option value="">{this.props.i18n.t("Select")}</Option>
                    <Option value="ready_to_dispense">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:Ready to transfer from the manufacturer"
                      )}
                    </Option>
                    <Option value="in_transit_manufacturer_depot">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:In transit to the depot"
                      )}
                    </Option>
                    <Option value="received_by_depot">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:Received by the depot"
                      )}
                    </Option>
                    <Option value="in_transit_depot_pharmacy">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:In transit to the pharmacy"
                      )}
                    </Option>
                    <Option value="received_by_pharmacy">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:Received by pharmacy"
                      )}
                    </Option>
                    <Option value="quarantined">
                      {this.props.i18n.t("Quarantined")}
                    </Option>
                    <Option value="reviewed_by_pharmacy_manufacturer">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:Reviewed at the pharmacy"
                      )}
                    </Option>
                    <Option value="validated_by_the_research_coordinator">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:Validated by the research coordinator"
                      )}
                    </Option>
                    <Option value="in_transit_pharmacy_fridge">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:In transit to the fridge"
                      )}
                    </Option>
                    <Option value="received_by_fridge">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:Received by the fridge"
                      )}
                    </Option>
                    <Option value="available">
                      {this.props.i18n.t("Available")}
                    </Option>
                    <Option value="assigned_to_a_patient">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:Assigned to a patient"
                      )}
                    </Option>
                    <Option value="allocated">
                      {this.props.i18n.t("Allocated")}
                    </Option>
                    <Option value="validated_by_the_research_coordinator">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:Validated by the research coordinator"
                      )}
                    </Option>
                    <Option value="no_longer_available_offline">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:No longer available / damaged"
                      )}
                    </Option>
                    <Option value="lost">{this.props.i18n.t("Lost")}</Option>
                    <Option value="sent_back_to_manufacturer">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:Sent back to manufacturer"
                      )}
                    </Option>
                    <Option value="sent_back_to_pharmacy">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:Sent back to site pharmacy"
                      )}
                    </Option>
                    <Option value="sent_back_to_depot">
                      {this.props.i18n.t(
                        "NamespaceEnrolmentsRandomize:Sent back to drug depot"
                      )}
                    </Option>
                  </Select>
                </div>
              )}
            </div>

            {errorMessage && <Alert type="error" message={errorMessage} />}

            {responseMessage && (
              <Alert type="success" message={responseMessage} />
            )}

            <div style={{ overflowY: "auto" }}>
              <Table
                style={{ minWidth: "1400px" }}
                columns={columns}
                dataSource={subject}
                loading={isLoading}
                rowKey="id"
                onChange={this.handleTableChange}
                pagination={{
                  onShowSizeChange: (current, size) => {
                    this.setState({ pageSize: size });
                  },
                  current: currentPage,
                  total,
                  pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "25", "50", "100"],
                  position: 'both',
                }}
              />
            </div>

            {isLoading && <Icon type="loading" />}

            <br />

            <h4 className="headline-default">{this.props.i18n.t("Legend")}</h4>
            <p className={classes.legendItem}>
              <Icon type="check-square" className={classes.checkIcon} />{" "}
              <b>{this.props.i18n.t("Complete")}</b>
            </p>

            <p className={classes.legendItem}>
              <Icon type="warning" className={classes.warningIcon} />{" "}
              <b>{this.props.i18n.t("Alert")}</b>
            </p>

            <p className={classes.legendItem}>
              <Icon type="clock-circle" className={classes.checkIconGray} />{" "}
              <b>{this.props.i18n.t("Pending")}</b>
            </p>
          </Content>

        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(EnrolmentsRandomize))
);



// WEBPACK FOOTER //
// ./src/containers/EnrolmentsRandomize/EnrolmentsRandomize.js